import { z } from 'zod';
import { parseFiniteNumber } from '../../parse-finite-number.js';
import { TRANSFER_ORDER_CONSTRAINTS } from './constraints.js';
// Bounds keep the value storable as non-zero and under overflow in the Decimal(28,9) column.
export const transferOrderQuantitySchema = z
    .number()
    .positive(`${TRANSFER_ORDER_CONSTRAINTS.quantity.label} must be greater than 0.`)
    .min(TRANSFER_ORDER_CONSTRAINTS.quantity.min, `${TRANSFER_ORDER_CONSTRAINTS.quantity.label} must be at least ${TRANSFER_ORDER_CONSTRAINTS.quantity.minText}.`)
    .max(TRANSFER_ORDER_CONSTRAINTS.quantity.max, `${TRANSFER_ORDER_CONSTRAINTS.quantity.label} must be ${TRANSFER_ORDER_CONSTRAINTS.quantity.maxText} or less.`);
export function parseTransferOrderQuantity(value) {
    const parsed = parseFiniteNumber(value);
    return parsed !== undefined && transferOrderQuantitySchema.safeParse(parsed).success
        ? parsed
        : undefined;
}
//# sourceMappingURL=item-quantity.js.map